import {useEffect, useState } from 'react';
import $ from 'jquery';
import { properties } from '../../properties';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';
import { getBasketCustomVars } from './BasketCustomVars';


function AuthSettle({ apiUrl }) {
    const [authSettle, setAuthSettle] = useState({
        operation: properties.OPERATIONS.authsettle,
        transactionid: transidgenerator(),
        timestamp: "",
        method: properties.HTTP_METHOD,
        vendorid: properties.VENDOR_ID,
        password: properties.PASSWORD,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        region: properties.SEL_REGION,
        address: properties.ADDRESS,
        postCode: properties.POST_CODE,
        countryCode: properties.COUNTRY_CODE,
        allowAvsFail: properties.ALLOW_AVS_FAIL,
        customerId: properties.CUSTOMER_ID,
        security:""
    });

    const [basketCount, setBasketCount] = useState(1);
    const [customVars, setCustomVars] = useState([]);
    const [isDpaFlag, setIsDpaFlag] = useState("false");

    useEffect(() => {
        const custom_vars = getBasketCustomVars(basketCount);
        setCustomVars(custom_vars);
    }, [basketCount]);

    var region =[];

    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }
    
    var canSubmit = true;

    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    function changeBasketCount(e) {
        setBasketCount(e.target.value);
        if (e === "" || !e || e.target.value < 1) {
            document.getElementsByName("WPG_basketCount")[0].classList.add("emptied");
            document.getElementsByName("WPG_basketCount")[1].classList.add("emptied");
            canSubmit = false;
        }
        else {
            document.getElementsByName("WPG_basketCount")[0].classList.remove("emptied");
            document.getElementsByName("WPG_basketCount")[1].classList.remove("emptied");
        }
    }

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setAuthSettle({ ...authSettle, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setAuthSettle({ ...authSettle, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setAuthSettle({ ...authSettle, password: e.target.value });
    }

    function changeDesc(e) {
        setAuthSettle({ ...authSettle, description: e.target.value });
    }

    function changeValue(e) {
        isNotNullCheck(e.target.value,"WPG_value");
        setAuthSettle({ ...authSettle, value: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value,"WPG_currency");
        setAuthSettle({ ...authSettle, currency: e.target.value });
    }

    function changeAddr(e) {
        setAuthSettle({ ...authSettle, address: e.target.value });
    }

    function changePostCode(e) {
        setAuthSettle({ ...authSettle, postCode: e.target.value });
    }

    function changeCountryCode(e) {
        setAuthSettle({ ...authSettle, countryCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setAuthSettle({ ...authSettle, region: e.target.value });
    }

    function changeAllowAvsFail(e) {
        setAuthSettle({ ...authSettle, allowAvsFail: e.target.value });
    }

    function changeCustomerId(e) {
        setAuthSettle({ ...authSettle, customerId: e.target.value });
    }

    function changeDpaFlag(e) {
        setIsDpaFlag(e.target.value);
    }

    function submitAuthSettleForm(e) {
        e.preventDefault();
        isNotNullCheck(authSettle.password,"vendorPwd");
        isNotNullCheck(authSettle.vendorid,"WPG_vendorID");
        isNotNullCheck(authSettle.transactionid,"WPG_transID");
        isNotNullCheck(authSettle.value,"WPG_value");
        isNotNullCheck(authSettle.region,"WPG_region");
        isNotNullCheck(authSettle.currency,"WPG_currency");
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(authSettle.region === "NoR"){
                setAuthSettle({...authSettle, region:""});
            }
            $("#pwd").remove();
            var md5 = require('md5');
            var time = Math.floor(Date.now() / 1000);
            $("#authsettle_timestamp").val(time);
            var digest = md5(time + authSettle.vendorid + authSettle.transactionid + authSettle.method + authSettle.description +
                authSettle.value + authSettle.currency + authSettle.region + authSettle.address + authSettle.postCode +
                authSettle.countryCode + authSettle.allowAvsFail + authSettle.password);
            $("#authsettle_security").val(digest);
            $("#authsettleForm").attr('action', apiUrl).submit();
        }
    }

    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

	var authSettleTemplate = (
        <div className="operation-form">
            <h2>Authorise & Settle</h2>
            <form className="form-horizontal" id="authsettleForm" method='post' onSubmit={submitAuthSettleForm}>
                <input type="hidden" name="WPG_operation" value={authSettle.operation} />
                <input type="hidden" name="WPG_CUSTOM_Operation" value={authSettle.operation} />
                <input type="hidden" name="WPG_method" value={authSettle.method}/>

                <div className="form-group">
                    <div className="control-label">
                        Number of Basket Items<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="number" className="form-control" name='WPG_basketCount' value={basketCount} onChange={changeBasketCount}
                        />
                        <div className="error-msg" name="WPG_basketCount">Basket Count should be at least 1</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Dpa Flag
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_dpaFlag" value={isDpaFlag} onChange={changeDpaFlag}>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={authSettle.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                     </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={authSettle.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group" id="pwd">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={authSettle.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={authSettle.description} onChange={changeDesc} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={authSettle.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={authSettle.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={authSettle.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Address
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_address" value={authSettle.address} onChange={changeAddr} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Postal/Zip Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_postcode" value={authSettle.postCode} onChange={changePostCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Country Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_countryCode" value={authSettle.countryCode} onChange={changeCountryCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow AVS Fail
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_allowAVSFail" onChange={changeAllowAvsFail} value={authSettle.allowAvsFail} >
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Id
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_customerId" value={authSettle.customerId} onChange={changeCustomerId} />
                    </div>
                </div>
                <input type="hidden" name="WPG_timestamp" id="authsettle_timestamp" value="" />
                <input type="hidden" name="WPG_security" id="authsettle_security" value="" />
                {customVars}
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary">Continue</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>
    );

    return authSettleTemplate;
}

export default AuthSettle;